export const fullPageCutoff = 1500
